/* eslint-disable no-nested-ternary */
import React, { FunctionComponent } from 'react';
import { Badge, BadgeProps, Flex, Icon, TypeColors } from '@bitrise/bitkit';
import getFormattedValue from '../../utils/metric/getFormattedValue';

type Props = {
  backgroundColor?: TypeColors;
  change: number | null;
  positiveDelta?: 1 | -1;
  textColor?: TypeColors;
  withText?: boolean;
} & BadgeProps;

const ChangeBadge: FunctionComponent<Props> = ({
  change,
  backgroundColor,
  positiveDelta = 1,
  textColor,
  withText = true,
  ...rest
}) => {
  if (change === null) {
    return null;
  }

  const changeText = getFormattedValue('percent', change && Math.abs(change));
  const changeRounded = parseFloat(changeText);
  const hasChanged = changeRounded !== 0;

  // eslint-disable-next-line prettier/prettier
  const dynamicBackgroundColor = positiveDelta === -1
    ? (change <= 0 ? 'green-1' : 'red-1')
    : (change >= 0? 'green-1' : 'red-1');

  // eslint-disable-next-line prettier/prettier
  const dynamicTextColor = positiveDelta === -1
    ? (change <= 0 ? 'green-5' : 'red-5')
    : (change >= 0? 'green-5' : 'red-5');

  return (
    <Badge
      {...rest}
      backgroundColor={backgroundColor || dynamicBackgroundColor}
      textColor={textColor || dynamicTextColor}
      weight="bold"
    >
      {hasChanged ? (
        <Flex alignChildren="middle" direction="horizontal">
          <Flex>
            <Icon name={change < 0 ? 'ChevronDown' : 'ChevronUp'} size="1rem" />
          </Flex>

          {withText && <Flex>{getFormattedValue('percent', change && Math.abs(change))}</Flex>}
        </Flex>
      ) : (
        'No Change'
      )}
    </Badge>
  );
};

export default ChangeBadge;
